import React from 'react';
import cn from 'classnames';
import './styles.scss';
import {LibraryFilter} from '../../../components/library/LibraryEnums';

interface ICategoryProps {
  title: string;
  id: number;
  serialNumber: string | undefined;
  checked?: boolean;
  onToggle: (serialNumber: string | undefined, id: number, checked: boolean, typeFilter: LibraryFilter) => void;
}

export const Category = ({
  title,
  id,
  serialNumber,
  checked = false,
  onToggle
}: ICategoryProps): JSX.Element => {
  const handleToggle = () => {
    onToggle(serialNumber, id, !checked, LibraryFilter.Categories);
  };

  return <div
    className={cn('category', {'category--checked': checked})}
    role="presentation"
    onClick={handleToggle}><div className="category__text">{title}</div>
  </div>;
};
